export const servicesCache = {
  data: null,
  promise: null,
  get: async () => {
    if (servicesCache.data) {
      return servicesCache.data;
    }
    if (servicesCache.promise) {
      return servicesCache.promise;
    }
    
    servicesCache.promise = fetch(`https://api.dev.auxo.dk/public/content/services`)
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch services');
        return res.json();
      })
      .then(data => {
        if (!Array.isArray(data)) throw new Error('Expected array');
        servicesCache.data = data;
        servicesCache.promise = null;
        return data;
      })
      .catch(err => {
        servicesCache.promise = null;
        throw err;
      });
      
    return servicesCache.promise;
  }
};
